<div class="container">
  <div class="row justify-content-center align-items-center pt-4">
    <div class="col-md-10 col-lg-10 col-xl-8 col-sm-12 col-sm-12">
      <nz-card nzTitle="Videojet Sales and Distributor Locator">
        <nz-spin [nzSpinning]="isLoading" nzTip="loading..." class="p-2">
          <form nz-form [formGroup]="searchForm" [nzLayout]="'vertical'">
            <div class="row">
              <div class="form-group col-md-6">
                <nz-form-item>
                  <nz-form-label nzFor="country">Country</nz-form-label>
                  <nz-form-control>
                    <nz-select
                      name="country"
                      id="country"
                      formControlName="country"
                      nzSize="small"
                      nzPlaceHolder="Select Country"
                      nzShowSearch="true"
                    >
                      <nz-option
                        *ngFor="let country of vjOfficeCountry"
                        [nzValue]="country.value"
                        [nzLabel]="country.label"
                      ></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div class="form-group col-md-6">
                <nz-form-item>
                  <nz-form-label nzFor="narrowSearch"
                    >Narrow Search Results By</nz-form-label
                  >
                  <nz-form-control>
                    <nz-select
                      name="narrowSearch"
                      id="narrowSearch"
                      formControlName="narrowSearch"
                      nzSize="small"
                      nzPlaceHolder="Select Type"
                      [(ngModel)]="selectedType"
                    >
                      <nz-option nzValue="all" nzLabel="All"></nz-option>
                      <nz-option
                        nzValue="distributors"
                        nzLabel="Distributors"
                      ></nz-option>
                      <nz-option
                        nzValue="offices"
                        nzLabel="Offices"
                      ></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
          </form>
          <nz-tag [nzColor]="'green'" *ngIf="this.selectedCountry">{{
            this.selectedCountry | uppercase
          }}</nz-tag>
          <nz-tag [nzColor]="'green'" *ngIf="this.selectedType">{{
            this.selectedType | uppercase
          }}</nz-tag>
        </nz-spin>
      </nz-card>
    </div>
  </div>
</div>

<!-- Data Tabs -->
<div class="container">
  <div class="row justify-content-center align-items-center">
    <div class="col-md-10 col-lg-10 col-xl-8 col-sm-12 col-sm-12">
      <nz-tabset
        [(nzSelectedIndex)]="selectedIndex"
        (nzSelectChange)="changeTab()"
        *ngIf="selectedCountry"
      >
        <!-- Distributor Data Tab
  
  *ngIf="(selectedCategory === 'Distributor' || !selectedCategory) && vjDistributorList && vjDistributorList.length > 0"
  -->
        <nz-tab
          [nzTitle]="'Distributors'"
          *ngIf="selectedType == 'distributors' || selectedType == 'all'"
        >
          <ng-template nz-tab>
            <nz-spin [nzSpinning]="isDataLoading" nzTip="loading..." class="p-2">
            <ng-container *ngIf="vjDistributorList">
              <!-- Display distributor data here -->
              <div class="scrollable-container">
                <div
                  class="record"
                  *ngFor="let distributor of vjDistributorList"
                >
                  <!-- Distributor content here -->
                  <nz-card>
                    <div class="row g-0">
                      <div class="col-1 text-center">
                        <i class="fas fa-building"></i>
                      </div>
                      <div class="col-11 text-left text-primary font-bold">
                        {{ distributor?.officialName }}
                      </div>
                      <div class="col-1 text-center">
                        <i class="fas fa-map-marker"></i>
                      </div>
                      <div class="col-11 text-left">
                        {{
                          distributor?.address1 ? distributor?.address1 : ""
                        }},<br />
                        <span *ngIf="distributor?.address2"
                          >{{
                            distributor?.address2 ? distributor?.address2 : ""
                          }},<br
                        /></span>
                        <span *ngIf="distributor?.city"
                          >{{ distributor?.city ? distributor?.city : "" }}<br
                        /></span>

                        {{ distributor?.state ? distributor?.state : "" }}<br />
                        {{
                          distributor?.countryName
                            ? distributor?.countryName
                            : ""
                        }}
                      </div>
                      <div
                        class="col-1 text-center"
                        *ngIf="distributor?.pocPhone1"
                      >
                        <i class="fas fa-phone"></i>
                      </div>
                      <div
                        class="col-11 text-left"
                        *ngIf="distributor?.pocPhone1"
                      >
                        <a href="tel:{{ distributor?.pocPhone1 }}">{{
                          distributor?.pocPhone1
                        }}</a>
                      </div>
                      <div class="col-1 text-center">
                        <i class="fas fa-envelope"></i>
                      </div>
                      <div class="col-11 text-left">
                        {{ distributor?.pocEmail ? distributor?.pocEmail : "" }}
                      </div>
                      <div
                        class="col-1 text-center"
                        *ngIf="distributor?.website"
                      >
                        <i class="fas fa-globe"></i>
                      </div>
                      <div
                        class="col-11 text-left"
                        *ngIf="distributor?.website"
                      >
                        <a href="{{ distributor?.website }}" target="_blank">{{
                          distributor?.website
                        }}</a>
                      </div>
                      <div
                        class="col-1 text-center"
                      ></div>
                      <div *ngIf="distributor?.additionalNotes" class="col-11 text-left" [innerHTML]="distributor?.additionalNotes">
                      </div>
                    </div>
                  </nz-card>
                </div>
              </div>
            </ng-container>
          </nz-spin>
            <span class="mt-4">
              <nz-empty *ngIf="vjDistributorList <= 0" nzNotFoundContent="If any queries, Please send it to it[dot]webportals[@]videojet.com"></nz-empty
            ></span>
          </ng-template>
        </nz-tab>

        <!-- Videojet Offices Location Data Tab 
  
    *ngIf="(selectedCategory === 'Videojet Offices' || !selectedCategory) && vjDataList && vjDataList.length > 0"
    
  -->
        <nz-tab
          [nzTitle]="'Offices'"
          *ngIf="selectedType == 'offices' || selectedType == 'all'"
        >
          <ng-template nz-tab>
            <nz-spin [nzSpinning]="isDataLoading" nzTip="loading..." class="p-2">
            <ng-container *ngIf="vjDataList">
              <!-- Display videojet offices data here -->
              <div class="scrollable-container">
                <div class="record" *ngFor="let vjData of vjDataList">
                  <!-- Videojet Offices content here -->

                  <nz-card>
                    <div class="row g-0">
                      <div class="col-1 text-center">
                        <i class="fas fa-building"></i>
                      </div>
                      <div class="col-11 text-left text-primary font-bold">
                        {{ vjData?.officialCompanyName }}
                      </div>
                      <div class="col-1 text-center">
                        <i class="fas fa-map-marker"></i>
                      </div>
                      <div class="col-11 text-left">
                        {{ vjData?.address1 ? vjData?.address1 : "" }},<br />
                        <span *ngIf="vjData?.address2"
                          >{{ vjData?.address2 ? vjData?.address2 : "" }},<br
                        /></span>
                        <span *ngIf="vjData?.city"
                          >{{ vjData?.city ? vjData?.city : "" }}<br
                        /></span>

                        {{ vjData?.state ? vjData?.state : "" }}<br />
                        {{ vjData?.countryName ? vjData?.countryName : "" }}
                      </div>
                      <div class="col-1 text-center" *ngIf="vjData?.phone1">
                        <i class="fas fa-phone"></i>
                      </div>
                      <div class="col-11 text-left" *ngIf="vjData?.phone1">
                        <a href="tel:{{ vjData?.phone1 }}">{{
                          vjData?.phone1
                        }}</a>
                      </div>
                      <div class="col-1 text-center" *ngIf="vjData?.phone2">
                        <i class="fas fa-phone"></i>
                      </div>
                      <div class="col-11 text-left" *ngIf="vjData?.phone2">
                        <a href="tel:{{ vjData?.phone2 }}">{{
                          vjData?.phone2
                        }}</a>
                      </div>
                      <div class="col-1 text-center" *ngIf="vjData?.fax">
                        <i class="fas fa-fax"></i>
                      </div>
                      <div class="col-11 text-left" *ngIf="vjData?.fax">
                        <a href="tel:{{ vjData?.fax }}">{{ vjData?.fax }}</a>
                      </div>
                      <div class="col-1 text-center" *ngIf="vjData?.email">
                        <i class="fas fa-envelope"></i>
                      </div>
                      <div class="col-11 text-left" *ngIf="vjData?.email">
                        {{ vjData?.email ? vjData?.email : "" }}
                      </div>
                      <div class="col-1 text-center" *ngIf="vjData?.website">
                        <i class="fas fa-globe"></i>
                      </div>
                      <div class="col-11 text-left" *ngIf="vjData?.website">
                        <a
                          href="{{ vjData?.website }}"
                          target="_blank"
                          >{{ vjData?.website }}</a
                        >
                      </div>
                    </div>
                  </nz-card>
                </div>
              </div>
            </ng-container>
</nz-spin>
            <span class="mt-4"
              ><nz-empty *ngIf="vjDataList.length <= 0" nzNotFoundContent="If any queries, Please send it to it[dot]webportals[@]videojet.com"></nz-empty
            ></span>
          </ng-template>
        </nz-tab>
      </nz-tabset>
    </div>
  </div>
</div>
<nz-back-top [nzTemplate]="tpl" [nzVisibilityHeight]="100">
  <ng-template #tpl>
    <div class="ant-back-top-inner">
      <span nz-icon nzType="arrow-up" nzTheme="outline"></span>
    </div>
  </ng-template>
</nz-back-top>
